import {Component, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiRestService as ProgettiApiRestService} from "../../Progetti/_services/api-rest.service";
import {TranslateObj} from "../../shared/models/translatedesc";
import {ProdottiStoreService} from "../../Progetti/_services/prodotti-store.service";
import {ToastrService} from "ngx-toastr";
import {Location} from "@angular/common";
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";

@Component({
  selector: 'app-codice-sconto-edit',
  templateUrl: './codice-sconto-edit.component.html',
  styleUrls: ['./codice-sconto-edit.component.css']
})
export class CodiceScontoEditComponent implements OnInit {
  environment = environment;
  Item: Prodotto = new Prodotto();
  id: number;
  type: number;
  private Backup: Prodotto;
  prezzo: string = "";
  UnitaDiMisura: ClassicType[] = [];
  UnitaDiMisuraSelezionata: ClassicType[] = [];
  unitadropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false ,
    allowRemoteDataSearch:true,
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private progettiApiRest: ProgettiApiRestService,
    private progettiStore: ProdottiStoreService,
    private toastService: ToastrService,
    private location: Location,
  ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.id = parseInt(data['id']);
      this.type = parseInt(data['type']);
      this.Item.tipo = this.type;
      this.Refresh(this.id);
    })
    this.Item.transaltedobjects = this.createlang(["en", "es", "fr", "de"]);
    this.progettiStore.getUnitaDiMisura();
    this.progettiStore.$unitaDiMisura.subscribe(data => this.UnitaDiMisura = data !== null? data:[]);
  }
  addPrezzo(){
    this.Item.prezzi = this.Item.prezzi? this.Item.prezzi : [];
    if (this.UnitaDiMisura?.length <= 1 || this.UnitaDiMisuraSelezionata?.length > 0) {
      if (this.Item.prezzi.findIndex(x => x.um === parseInt(this.UnitaDiMisura?.length <= 1 ? this.UnitaDiMisura[0].id : this.UnitaDiMisuraSelezionata[0].id)) < 0)
        this.Item.prezzi.push({
          prezzo: parseFloat(this.prezzo),
          um: this.UnitaDiMisura?.length <= 1 ? parseInt(this.UnitaDiMisura[0].id): parseInt(this.UnitaDiMisuraSelezionata[0].id),
          umlabel: this.UnitaDiMisura?.length <= 1 ? this.UnitaDiMisura[0].label : this.UnitaDiMisuraSelezionata[0].label
        });
      else if (isNaN(parseFloat(this.prezzo)))
        this.toastService.warning("Inserire un prezzo", 'Attenzione!');
      else
        this.toastService.info("Questa unita di misura è stata gia inserita", 'Info!');
    }
    else
      this.toastService.warning("Inserire un unità di misura", 'Attenzione!');
    console.log(this.Item.prezzi);
  }
  deletePrezzo(value){
    const idx = this.Item.prezzi.findIndex(x=>x.um === value.um);
    if(idx > -1)
      this.Item.prezzi.splice(idx,1);
  }
  Refresh(id: number) {
    if(id) {
      this.progettiApiRest.getInfoProdotto({id: id}).subscribe(data => {
        this.Item = data;
        this.compilaForm(data);
      });
    }

  }
  private compilaForm(data: Prodotto) {
    this.Item.transaltedobjects = data.id? this.gettransaltedobjects(data) : this.createlang(["en", "es", "fr", "de"]);
    this.Backup = this.Item;
    this.Item.tipo = this.type;
    this.Item['categorieObject'] = [...data.categorie];
    console.log(this.Item);
  }

  createlang(langs: string[]): TranslateObj [] {
    return [
      {default: true, lang: "it", TranslateInputs: this.TranslateInputs()},
      ...langs.map(value => {
        return {
          default: false,
          lang: value,
          TranslateInputs: this.TranslateInputs()
        }
      })];
  }

  gettransaltedobjects(prodotto: Prodotto): TranslateObj[]{
    return [
      {
        default: true,
        lang: "it",
        TranslateInputs: this.TranslateInputs(prodotto)
      },...prodotto.traduzioni
    ];
  }

  TranslateInputs(prodotto?: Prodotto) : any[]{
    return [...environment.ProdottiAddOn['TraduzioniCodiciSconto']?.map(campo => {return {id: campo.id, label:campo.label, value: prodotto ? prodotto[campo.value] : "", type: campo.type}}) ?? []];
}

  FilterHandler($event: { OnFilter: string; Event: any }) {

  }

  ChangeHandler($event: { OnChange: string; Event: any }) {

  }
  private getDaForm() {
    this.Item.traduzioni = this.Item.transaltedobjects?.filter(x => !x.default)
    let out: Prodotto = this.Item;
    if(environment.ProdottiAddOn.TranslatedDesc)
      this.Item?.transaltedobjects?.find(x => x.default)?.TranslateInputs?.forEach(translateInput => {
        out[translateInput?.id] = translateInput?.value;
      })
    return out;
  }

  saveClick(close?:boolean) {
    if (this.Item.id)
      this.progettiApiRest.updateProdotti(this.getDaForm()).subscribe(() => {
        if(close)
          this.location.back()
      });
    else
      this.progettiStore.addNewItem(this.getDaForm()).subscribe(data => {
        if(close)
          this.location.back()
        else if(data?.id)
          this.Refresh(data?.id)
      });
  }

  cancel() {
    this.location.back();
  }
}
